import React from 'react'
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import Breadcrumbs from '../Components/banner/New-banner';
import Address from '../Components/User-Dashboard/Address';
function Addresspage() {
    return (
        <>
            <Combaintop />
            <Breadcrumbs />
            <Address/>
            <Combainbottom />
        </>

    )
}

export default Addresspage